import { Injectable } from '@angular/core';
import {
  ContractPillRemoteAsset,
  ImageConverterInterface,
  PRODUCT_COMPARE_DIMENSIONS,
} from '@usf/file-share-utils';
import { convertBase64SvgToPng } from './document-creation.helpers';

@Injectable({
  providedIn: 'root',
})
export class ImageConverterHelpersService implements ImageConverterInterface {
  constructor() {}

  convertBase64SvgToPng(
    base64Svg: string,
  ): Promise<ContractPillRemoteAsset | null> {
    const { pillWidth, pillHeight } = PRODUCT_COMPARE_DIMENSIONS;
    return convertBase64SvgToPng(base64Svg, pillWidth, pillHeight);
  }
}
